import type { RefObject } from 'react'
import { applyChange, getLineStart, getLineEnd } from '../utils'

export const clearLineAction = (
  textareaRef: RefObject<HTMLTextAreaElement>,
  value: string,
  onChange: (val: string) => void,
): boolean => {
  const el = textareaRef.current
  if (!el) return false

  const s = el.selectionStart ?? 0
  const e = el.selectionEnd ?? s

  const delStart = getLineStart(value, s)
  const endIndex = e > s ? e - 1 : s
  const delEnd = getLineEnd(value, endIndex)

  const next = value.slice(0, delStart) + value.slice(delEnd)

  applyChange(textareaRef, onChange, next, delStart)
  return true
}
